export default __webpack_public_path__ + "c2fe17b06ea2166519e9320ae5d456eb.png";